import { FileText } from 'lucide-react'
import type { OcrResult } from '@shared/schemas'
import { AREA_ICON } from '@/components/pictograms'

export function OcrPreview({ ocr }: { ocr: OcrResult }) {
  const Icon = AREA_ICON[ocr.type] ?? FileText
  return (
    <div className="w-full rounded-3xl bg-white border border-slate-200 shadow-sm p-6 flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <div className="rounded-2xl bg-emerald-50 p-3">
          <Icon className="h-6 w-6 text-emerald-600" />
        </div>
        <div className="min-w-0">
          <div className="text-xs uppercase tracking-wide text-slate-500">Nová smlouva</div>
          <div className="text-base font-semibold truncate">{ocr.insurer}</div>
        </div>
      </div>
      <dl className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
        <Field label="Typ" value={czechAreaLabel(ocr.type)} />
        <Field label="Pojistné" value={`${ocr.premium_czk.toLocaleString('cs-CZ')} Kč / rok`} />
        <Field label="Platí od" value={ocr.valid_from} />
        <Field label="Platí do" value={ocr.valid_to} />
        <Field label="Číslo smlouvy" value={ocr.contract_number} />
        <Field label="Pojištěných" value={`${ocr.insured_person_ids.length}`} />
      </dl>
    </div>
  )
}

function Field({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex flex-col">
      <dt className="text-[10px] uppercase tracking-wide text-slate-400">{label}</dt>
      <dd className="text-slate-800 font-medium truncate">{value}</dd>
    </div>
  )
}

export function czechAreaLabel(code: string): string {
  switch (code) {
    case 'liability_personal':
      return 'Odpovědnost za škodu'
    case 'vehicle_mtpl':
      return 'Povinné ručení'
    case 'property_building':
      return 'Pojištění nemovitosti'
    case 'property_home':
      return 'Pojištění domácnosti'
    case 'travel':
      return 'Cestovní pojištění'
    case 'life':
      return 'Životní pojištění'
    default:
      return code
  }
}
